export const categories = [
  {
    slug: 'all',
    name: '全部平台',
    description: '所有韩漫平台入口汇总',
    icon: 'ri-apps-line',
  },
  {
    slug: 'popular',
    name: '热门推荐',
    description: '人气最高的韩漫平台',
    icon: 'ri-fire-line',
  },
  {
    slug: 'free',
    name: '免费韩漫',
    description: '免费观看韩漫的平台',
    icon: 'ri-vip-diamond-line',
  },
  {
    slug: 'premium',
    name: '精品韩漫',
    description: '高品质韩漫阅读平台',
    icon: 'ri-star-line',
  },
  {
    slug: 'new',
    name: '最新上线',
    description: '最近新增的韩漫平台',
    icon: 'ri-rocket-line',
  },
  {
    slug: 'aggregator',
    name: '聚合导航',
    description: '一站式韩漫网址大全',
    icon: 'ri-compass-3-line',
  },
];